import React from "react";
import UnifiedDocument from "./UnifiedDocument";
import { DOCUMENT_TYPES } from "../config/DocumentConfig";

const UnifiedDeliveryOrder = () => {
  return <UnifiedDocument documentType={DOCUMENT_TYPES.DELIVERY_ORDER} />;
};

export default UnifiedDeliveryOrder;
